import styled from 'styled-components';
import { cssVars } from '../../../shared/lib/styledTheme';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: ${cssVars.bgSecondary};
  border-radius: 8px;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid ${cssVars.borderColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  color: ${cssVars.textSecondary};
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;
`;

export const LoadingText = styled.div`
  text-align: center;
  padding: 40px;
  color: ${cssVars.textSecondary};
  font-size: 14px;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
`;

export const EmptyStateText = styled.div`
  color: ${cssVars.textSecondary};
  font-size: 14px;
`;

export const TicketsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TicketItem = styled.div`
  background-color: ${cssVars.bgColor};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: ${cssVars.primary};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const TicketHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const TicketTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  flex: 1;
`;

export const TicketSite = styled.span`
  padding: 4px 8px;
  background-color: ${cssVars.bgTertiary};
  border-radius: 4px;
  font-size: 12px;
  color: ${cssVars.textSecondary};
  margin-left: 12px;
`;

export const TicketInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const StatusBadge = styled.span<{ $color: string }>`
  padding: 4px 8px;
  background-color: ${props => props.$color}20;
  color: ${props => props.$color};
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
`;

export const TicketDate = styled.span`
  font-size: 12px;
  color: ${cssVars.textSecondary};
`;

export const MessagePreview = styled.div`
  font-size: 13px;
  color: ${cssVars.textSecondary};
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid ${cssVars.borderColor};
`;

